/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tracking_Mode_AllInputs */

const vi_tracking_mode_all = /** @type {(inputs: Tracking_Mode_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toàn bộ hành trình • ${i?.count} chặng`)
};

/**

* @param {Tracking_Mode_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_mode_all = /** @type {((inputs: Tracking_Mode_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Mode_AllInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_mode_all(inputs)
});